import http from '@/http/service'
 

export default function Usuarios(params={}){

    return http.get("/parceiro/usuarios",{ params })

}